import React from "react"
import tw from "twin.macro"
import styled from "@emotion/styled"
import { useStaticQuery, graphql, Link } from "gatsby"
import Image from "gatsby-image"

import { FooterQuery } from "../../graphql-types"

export const Footer: React.FC = () => {
  const data: FooterQuery = useStaticQuery(graphql`
    query Footer {
      logo: file(absolutePath: { regex: "/logo-basket-white.png/" }) {
        childImageSharp {
          fluid {
            ...GatsbyImageSharpFluid
          }
        }
      }
    }
  `)

  return (
    <>
      <svg viewBox="0 0 1440 53" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M0 39.75L120 41.9445C240 44.3047 480 48.4453 720 41.9445C960 35.1953 1200 17.8047 1320 8.81953L1440 0V53H1320C1200 53 960 53 720 53C480 53 240 53 120 53H0V39.75Z"
          fill="#2D3748"
        />
      </svg>

      <Styles.Wrapper>
        <Link to="/">
          <Styles.Logo
            fluid={data.logo.childImageSharp.fluid}
            alt="MixCart Logo"
          />
        </Link>
        <Styles.Items>
          <Styles.Item className="snipcart-checkout">Cart</Styles.Item>
          <Styles.Item>About</Styles.Item>
          <Styles.Item>Profile</Styles.Item>
          <Link to="/search">
            <Styles.Item>Products</Styles.Item>
          </Link>
        </Styles.Items>
        <Styles.Copyright>
          ©{new Date().getFullYear()}{" "}
          <Styles.PortfolioLink href="https://jfelix.info" target="__blank">
            Jose Felix
          </Styles.PortfolioLink>
        </Styles.Copyright>
      </Styles.Wrapper>
    </>
  )
}

const Styles = {
  Wrapper: styled.footer`
    ${tw`flex flex-col items-center justify-center px-6 py-10 bg-gray-800`}

    & > *:not(:last-child) {
      ${tw`mb-8`}
    }
  `,
  Logo: tw(Image)`w-16`,
  Items: styled.nav`
    ${tw`flex flex-col items-center justify-center sm:flex-row `}

    & > *:not(:last-child) {
      ${tw`mb-2 sm:mb-0 sm:mr-8`}
    }
  `,
  Item: tw.p`text-lg text-white transition-transform duration-100 transform cursor-pointer hover:scale-105`,
  Copyright: tw.p`text-sm text-gray-200`,
  PortfolioLink: tw.a`text-sm underline`,
}
